import { Button, Box, Flex, Icon, Text } from '@vibe/core';
import { Heading } from '@vibe/core';
import { WarningFull, Alert } from '@vibe/icons';

type ErrorBoxProps = {
  headline: string;
  description: string;
  type?: 'error' | 'info';
  buttonLabel?: string;
  onButtonClick?: () => void;
  innerContent?: React.ReactNode;
  heightOffset?: string;
};

function ErrorBox({
  headline,
  description,
  onButtonClick,
  buttonLabel,
  innerContent,
  type = 'error',
  heightOffset = '0px',
}: ErrorBoxProps) {
  return (
    <Flex
      justify="center"
      align="center"
      style={{
        width: '100%',
        height: `calc(100vh - ${heightOffset})`,
        textAlign: 'center',
      }}
    >
      <Box
        style={{
          overflow: 'visible',
          maxWidth: '400px',
        }}
      >
        <Flex direction="column" gap={4}>
          <Flex direction="column" gap={4} style={{ marginBottom: '4px' }}>
            <Icon icon={type === 'error' ? Alert : WarningFull} size={26} />
          </Flex>
          <Flex direction="column" gap={8}>
            <Heading type="h3" weight="bold" align="center" color="primary" ellipsis={false}>
              {headline}
            </Heading>
            <Text type="text2" align="center" color="secondary" ellipsis={false}>
              {description}
            </Text>
          </Flex>
          {buttonLabel ? (
            <Button
              kind="primary"
              size="medium"
              style={{ marginTop: '20px' }}
              onClick={() => {
                if (onButtonClick) {
                  onButtonClick();
                }
              }}
            >
              {buttonLabel}
            </Button>
          ) : null}
          {innerContent}
        </Flex>
      </Box>
    </Flex>
  );
}

export default ErrorBox;
